import React, { useState } from "react";
import Select from "react-select";
import { Button } from "aible";

import ImpliedStrategy from "containers/UnifiedProject/RealityCheck/ImpliedStrategy";

import { isEnabled } from "utils/featureFlags";

import styles from "./style.module.css";

const Introspect = (props) => {
  const { runId, fields, introspectCountsFromData, dataset } = props;

  const [introspectColumn, setIntrospectColumn] = useState(undefined);
  const [introspectColumnValue, setIntrospectColumnValue] = useState(undefined);

  //const { introspectColumn, introspectColumnValue } = this.state || {};

  const datasetOutcome = dataset && dataset.outcome;

  return isEnabled("advanced-strategy") !== true ? (
    <div />
  ) : (
    <div className={styles.introspectSelectionContainer}>
      <div style={{ fontWeight: "bold", fontSize: "16px", marginBottom: "10px" }}>
        {"Would you like to evaluate if use behavior is aligned with your primary strategy?"}
      </div>
      <ImpliedStrategy id={runId} />
      <div style={{ display: "flex", marginTop: "10px" }}>
        <div className={styles.outcomePicker} style={{ fontWeight: "bold" }}>
          Variable
        </div>
        <div className={styles.outcomePicker} style={{ fontWeight: "bold" }}>
          Value
        </div>
      </div>
      <div className={styles.optionsSelect}>
        <Select
          value={introspectColumn === undefined ? undefined : { value: introspectColumn, label: introspectColumn }}
          onChange={(v) => {
            setIntrospectColumn(v.value);
            setIntrospectColumnValue(undefined);
          }}
          options={
            fields
              ? Object.keys(fields)
                  .filter(
                    (d) =>
                      fields[d].type === "categorical" &&
                      fields[d].data &&
                      fields[d].data.length == 2 &&
                      fields[d].label !== datasetOutcome
                  )
                  .map((d) => ({
                    label: d,
                    value: d
                  }))
              : []
          }
          className={styles.outcomePicker}
          placeholder={"Select Column to Introspect Counts"}
          label="Column"
          menuPlacement="top"
        />
        <Select
          isDisabled={introspectColumn === undefined}
          value={
            introspectColumnValue === undefined ? null : { value: introspectColumnValue, label: introspectColumnValue }
          }
          onChange={(v) => setIntrospectColumnValue(v.value)}
          options={((fields || {})[introspectColumn] || { data: [] }).data.map(({ value }) => ({
            label: value,
            value: value
          }))}
          className={styles.outcomePicker}
          placeholder={"Select Success Value"}
          label="Success Value"
          menuPlacement="top"
        />
      </div>
      <div className={styles.introspectSelectionButtonRow}>
        <Button
          disabled={introspectColumn === undefined || introspectColumnValue === undefined}
          onClick={() => introspectCountsFromData(runId, introspectColumn, introspectColumnValue)}
        >
          {"Evaluate Strategic Behavior"}
        </Button>
      </div>
    </div>
  );
};

export default Introspect;
